import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export function Reveal({ children, delay = 0, y = 28, className = "", ...props }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, ease: EASE, delay }}
      {...props}
    >
      {children}
    </motion.div>
  );
}

// Masked, line-by-line word reveal for headings
export function MaskText({ lines, className = "", lineClass = "", delay = 0, animateOnLoad = true }) {
  const parent = animateOnLoad ? "animate" : undefined;
  return (
    <div className={className}>
      {lines.map((line, i) => (
        <span key={i} className="reveal-line">
          <motion.span
            className={`block ${lineClass}`}
            initial={{ y: "110%" }}
            {...(animateOnLoad
              ? { animate: "animate" }
              : { whileInView: { y: "0%" }, viewport: { once: true, margin: "-60px" } })}
            variants={{ animate: { y: "0%" } }}
            transition={{ duration: 1, ease: EASE, delay: delay + i * 0.12 }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </div>
  );
}

export { EASE };
